import React from 'react'
import { Redirect, Route, } from 'react-router-dom'
import { debugLog } from '../util/debug';
import { UseGlobalState } from '../state/gsh/gsh';

const AuthorizedRoute = ({ component: Component, ...rest }) => {
    const state = UseGlobalState()[0]

    return (
        <Route {...rest} render={props => {
            debugLog("AuthorizedRoute: ", props.location.pathname)

            if (state.loggedOn) {
                return <Component {...props} />
            }
            if (['/', '/maritz-sso',].includes(props.location.pathname)) {
                return <Component {...props} />
            }

            return <Redirect to="/" />
        }} />
    )
}

export default AuthorizedRoute;